import React from 'react';

import { generateInvoice } from 'api';
import { transformErrorResponse } from 'helpers/errors';
import FormError from '../FormError';

export default class GenerateRenewalInvoiceButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: undefined,
      success: false,
      paid: false,
      use_credit: false,
    };

    this.onCheckboxChange = this.onCheckboxChange.bind(this);
  }

  async generateInvoice(userId, use_credit) {
    try {
      const { status, data } = await generateInvoice(userId, use_credit);

      if (status === 204) {
        this.setState({
          paid: true,
        });
        return;
      }

      const { id } = data;
      if (status === 200 || status === 201) {
        this.setState({
          success: id,
        });
      }
    } catch ({ response }) {
      const error = transformErrorResponse(response.data);
      this.setState({
        error,
        isSent: false,
      });
    }
  }

  onCheckboxChange({ currentTarget }) {
    this.setState({
      use_credit: currentTarget.checked,
    });
  }

  render() {
    const { userId, onComplete } = this.props;
    const { error, success, paid, use_credit } = this.state;
    const isDisabled = error || success || paid;

    if (success && onComplete) {
      return onComplete(success);
    }

    return userId ? (
      <div>
        <div>
          <button
            onClick={() => this.generateInvoice(userId, use_credit)}
            className="btn btn-primary"
            disabled={isDisabled}
          >
            Generate Renewal Invoice
          </button>
          <label className="mar-l">
            <input
              type="checkbox"
              name="use_credit"
              onChange={this.onCheckboxChange}
              checked={use_credit}
            />{' '}
            Apply Credit
          </label>
        </div>
        {error ? <FormError error={error} /> : null}
        {success ? (
          <div className="text-success">Invoice Successfully Generated.</div>
        ) : null}
        {paid ? (
          <div className="text-success">Invoice has already been paid.</div>
        ) : null}
      </div>
    ) : null;
  }
}
